import React from 'react';

import { Input, WebCopy } from 'components/shared/';

interface EmailInputProps {
  /** @string - Email address */
  email?: string;
  /** @any - Error object with email property */
  errors?: any;
  /** @string - Classname to be passed to the Input component */
  className?: string;
  /** @string - Email label to be passed to the Input component */
  emailLabel?: string;
  /** @function - Function that will be called when the Input changes value */
  handleEmailChanged?: any;
}

const EmailInput: React.FC<EmailInputProps> = ({
  className,
  emailLabel,
  email,
  errors,
  handleEmailChanged,
}) => {
  const hasError = !!errors && !!errors.email;

  return (
    <>
      <Input
        fullWidth
        className={className}
        error={hasError}
        value={email}
        label={emailLabel}
        onChange={handleEmailChanged}
      />

      {hasError && <WebCopy type="Error">{errors!.email}</WebCopy>}
    </>
  );
};

export default EmailInput;
